import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const API_URL = '';

const DEFAULT_ICONS = {
  warteliste:    '📋',
  kontakt:       '✉️',
  probetraining: '🏊',
};

const FALLBACK_KACHELN = [
  { id: 1, key: 'warteliste',    titel: 'Warteliste',    beschreibung: 'Trage dich auf unsere Warteliste ein',   route: '/warteliste',    bild_pfad: null },
  { id: 2, key: 'kontakt',       titel: 'Kontakt',       beschreibung: 'Schreib uns eine Nachricht',             route: '/kontakt',       bild_pfad: null },
  { id: 3, key: 'probetraining', titel: 'Probetraining', beschreibung: 'Beantrage ein kostenloses Probetraining',route: '/probetraining', bild_pfad: null },
];

export default function Startseite() {
  const [kacheln, setKacheln] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/api/kacheln')
      .then(r => setKacheln(r.data))
      .catch(() => setKacheln(FALLBACK_KACHELN))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="tile-container">
        <div className="tile-grid tile-grid--skeleton">
          {[1, 2, 3].map(i => <div key={i} className="tile tile--skeleton" />)}
        </div>
      </div>
    );
  }

  if (kacheln.length === 0) {
    return (
      <div className="tile-container">
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '2rem' }}>
          Keine Optionen verfügbar.
        </p>
      </div>
    );
  }

  return (
    <div className="tile-container">
      <div className="tile-grid">
        {kacheln.map(k => (
          <div
            key={k.id}
            className="tile"
            onClick={() => navigate(k.route)}
            role="button"
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && navigate(k.route)}
            aria-label={k.titel}
          >
            <div className="tile-img-wrap">
              {k.bild_pfad ? (
                <img
                  src={`${API_URL}/uploads/${k.bild_pfad}`}
                  alt={k.titel}
                  className="tile-img"
                />
              ) : (
                <div className="tile-img-placeholder">
                  <span className="tile-icon">{DEFAULT_ICONS[k.key] || '→'}</span>
                </div>
              )}
            </div>
            <div className="tile-body">
              <h3 className="tile-titel">{k.titel}</h3>
              {k.beschreibung && <p className="tile-text">{k.beschreibung}</p>}
            </div>
            <div className="tile-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
}
